import { TopBar } from "@/components/TopBar";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Reveal } from "@/components/Reveal";
import { BUSINESS } from "@/lib/constants";

export const LegalSection = ({ id, title, children }) => (
  <section id={id} data-testid={`legal-section-${id}`} className="scroll-mt-24">
    <h2 className="font-heading text-xl font-semibold tracking-tight text-[#F2EEE3] sm:text-2xl">{title}</h2>
    <div className="mt-4 space-y-4 text-sm leading-relaxed text-[#B8B2A6] sm:text-base">{children}</div>
  </section>
);

export const LegalLayout = ({ title, subtitle, children, testId }) => (
  <div data-testid={testId}>
    <TopBar />
    <Navbar sticky={false} />
    <main>
      <div className="bg-[#08080A] py-16 lg:py-20">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <Reveal>
            <h1 data-testid={`${testId}-title`} className="font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
              {title}
            </h1>
            <p className="mt-4 text-sm text-[#C6C0B4] sm:text-base">{subtitle}</p>
          </Reveal>
        </div>
      </div>
      <div className="bg-[#0E0E12] py-16 lg:py-20">
        <div className="mx-auto max-w-4xl space-y-12 px-4 sm:px-6 lg:px-8">
          <Reveal>
            <div className="rounded-xl border border-white/10 bg-[#141419] p-6" data-testid={`${testId}-business-block`}>
              <p className="font-heading text-base font-semibold text-[#F2EEE3]">{BUSINESS.name}</p>
              <p className="mt-1 text-sm text-[#B8B2A6]">
                195 Malabar Rd, Suite #3
                <br />
                Palm Bay, FL 32907
              </p>
              <a href={BUSINESS.phoneHref} data-testid={`${testId}-phone-link`} className="mt-2 inline-block text-sm font-semibold text-[#D8B54A] hover:text-[#E4C463]">
                {BUSINESS.phone}
              </a>
            </div>
          </Reveal>
          {children}
        </div>
      </div>
    </main>
    <Footer />
  </div>
);
